import React, { useState } from "react";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import AddIcon from "@mui/icons-material/Add";
import { hitCreateProfileApi } from "../../../Redux/Professional/CreateProfileSlice";
import { hitGetProfileApi } from "../../../Redux/Professional/GetProfileSlice";
import { showToast } from "../../../Helper/Toast";
import { useSelector } from "react-redux";
import { height, width } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import four1 from "../../../assets/img/four 1.svg";
import four2 from "../../../assets/img/four 2.svg";
import four3 from "../../../assets/img/four 3.svg";
import four4 from "../../../assets/img/four 4.svg";
import four5 from "../../../assets/img/four 5.svg";
import four6 from "../../../assets/img/four 6.svg";
import four7 from "../../../assets/img/four 7.svg";
import four8 from "../../../assets/img/four 8.svg";
import successIcon from "../../../assets/img/tick signup-three icon.svg";
import EarlySupporterDiscount from "../../../assets/img/Early Supporter Discount.svg";

import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";

import {stripeKey, monthlyPlanPriceId, yearlyPlanPriceId, ApiBaseUrl, createStripeSessionSubscriptionProfessional} from "../../../Utils/Constants";




const SignUpStepFour = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [professionalData, setProfessionalData] = useState(null);
  const [formData, setFormData] = useState({
    profileSteps: 4,
  });

  useEffect(() => {
    const storedData = localStorage.getItem("professionalToken");
  
    if (storedData) {
      fetchProfessionalData();
    }
  }, []);

  const fetchProfessionalData = async () => {
    try {
      const response = await dispatch(hitGetProfileApi());
      setProfessionalData(response.payload.data);
    } catch (error) {
      console.error("Error fetching professional data:", error);
    }
  };



  
    const stripePromise = loadStripe(stripeKey);
  
    const handleSubscriptionWhenNoPlan = async () => {
      //console.log("handleSubscriptionWhenNoPlanCalled");
  
      let priceId = "";
      // if (planName === "Pro Plan Annual") {
      //     priceId = yearlyPlanPriceId;
      // } else if (planName === "Pro Plan Monthly") {
      priceId = monthlyPlanPriceId;
      //}
  
     // const token = localStorage.getItem("professionalTokenMobileRedirection");
      // remove " from token string"
      let storedData = localStorage.getItem("professionalToken");
    
  
      const stripe = await stripePromise;
  
      const response = await axios.post(
        `${ApiBaseUrl}${createStripeSessionSubscriptionProfessional}`,
        {
          // amount: selectedCredits.amount * 100, // Amount in cents
          priceId: priceId,
          isFromOfferPage: 1,
          isFromOnboarding:1
          // You can add more details here as needed
        },
        {
          headers: {
            Authorization: storedData,
          },
        },
      );
  
      if (response.data.status === true) {
        window.location.href = response.data.data.url; // Redirect to Stripe Checkout
      } else {
        showToast(response.data.data.message, "error");
      }
    };
  
    useEffect(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);
  
    const handleViewDetails = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
  



  const submitFourthStep = async (e) => {
    e.preventDefault();
    try {
      formData.profileSteps = 4;
      await dispatch(hitCreateProfileApi(formData));
      navigate("/professional/dashboard");
      window.location.reload();
    } catch (error) {
      console.error("Error sending verification code:", error);
    }
  };

  return (
    <div className="custom_container pro-signup-page">
      <div className="business-form-4">
        {/* Header */}
        {/* <div className="business-form__header_4">
          <div className="business-form__step_4">
            <span className="business-form__step_badge_4">
              <DoneOutlinedIcon />
            </span>
            <div>
              <span className="title_head_4">Offer</span>
              <p className="business-form__step__number_4 mb-0">Step 4 of 4</p>
            </div>
          </div>
          <p className="business-form__exit_4">4/4</p>
        </div> */}
        <div className="business-form">
          <div
            className="bussiness-form-header-top"
            style={{ background: "#f1f7fd" }}
          >
            <div className="business-form__header">
              <div
                className="business-form__step"
                style={{ alignItems: "center" }}
              >
                <span
                  className="business-form__step-badge"
                  style={{
                    background:
                      "linear-gradient(90deg, #cc4645 0%, #9a1d1c 100%)",
                  }}
                >
                  4
                </span>
                <div>
                  <span className="title_head" style={{ color: "#cc4645" }}>
                    Business Details
                  </span>
                </div>
              </div>
              <p className="business-form__exit">4/4</p>
            </div>
            <div
              className="progress-bar-container"
              style={{ background: "#edf0f3" }}
            >
              <div
                className="progress-bar-fill"
                style={{
                  width: "100%",
                  background:
                    "linear-gradient(90deg, #cc4645 0%, #9a1d1c 100%)",
                }}
              ></div>
            </div>
            <p
              className="business-form__step__number mb-0"
              style={{
                background: "#fff",
                color: "#6a7280",
                fontWeight: "500",
                padding: "6px 12px",
                marginTop: 10,
              }}
            >
              Step 4 of 4
            </p>
          </div>
        </div>

        {/* Title */}
        <div className="business-form__title_4 mt-0 mb-4">
          <div className="service_area_search">
            <p>
              {/* <SearchIcon /> */}
              <span>
                {" "}
                <img
                  src={EarlySupporterDiscount}
                  alt="EarlySupporterDiscount"
                  className="mb-1 me-2"
                />
                Early Supporter Discount
              </span>
            </p>
          </div>
        </div>

        {/* Form */}
        <form>
          <div className="service-area">
            <div className="service-area__price">
              <h2>$ 149 /month</h2>
              <h1>$99 </h1>
              <span>/month</span>
            </div>
            <div className="business-form__title_4 mt-0">
              <div className="service_area_search">
                <p>
                  <span>33.56% OFF Founder Pricing</span>
                </p>
              </div>
            </div>

            <div className="expand-area">
              <div className="expand-button">
                <span>
                  <img src={four1} alt="Credit" />
                </span>
              </div>
              <div>
                <p>
                  100 Credits Per Month
                  <br />
                  <span>Use for bids, boosts, and much more.</span>
                </p>
              </div>
            </div>
            <div className="expand-area">
              <div className="expand-button">
                <span>
                  <img src={four2} alt="Boosted_Visibility" />
                </span>
              </div>
              <div>
                <p>
                  Top-Listed Pro Visibility <br />
                  <span>
                    Appear as a recommended professional in client searches.
                  </span>
                </p>
              </div>
            </div>
            <div className="expand-area">
              <div className="expand-button">
                <span>
                  <img src={four3} alt="Exclusive_Promotions" />
                </span>
              </div>
              <div>
                <p>
                  Exclusive Promotions <br />
                  <span>Direct, non-competitive bids sent to you.</span>
                </p>
              </div>
            </div>
            <div className="expand-area">
              <div className="expand-button">
                <span>
                  <img src={four4} alt="Import_Reviews" />
                </span>
              </div>
              <div>
                <p>
                  Import Reviews
                  <br />
                  <span>Import your Google business reviews.</span>
                </p>
              </div>
            </div>
            <div className="expand-area">
              <div className="expand-button">
                <span>
                  <img src={four5} alt="Full_Client_Insights" />
                </span>
              </div>
              <div>
                <p>
                  Full Client Insights <br />
                  <span>View past jobs, budget ranges, and total spends.</span>
                </p>
              </div>
            </div>
            <div className="expand-area">
              <div className="expand-button">
                <span>
                  <img src={four6} alt="Bid_credit_protection" />
                </span>
              </div>
              <div>
                <p>
                  Bid Credit Protection <br />
                  <span>Credits refunded if the job posting is removed.</span>
                </p>
              </div>
            </div>
            <div className="expand-area">
              <div className="expand-button">
                <span>
                  <img src={four7} alt="Bid_credit_protection" />
                </span>
              </div>
              <div>
                <p>
                  Ready-to-Go (RTG) Job Access <br />
                  <span>
                    Bid on high-intent clients ready to hire immediately.
                  </span>
                </p>
              </div>
            </div>
            <div className="expand-area">
              <div className="expand-button">
                <span>
                  <img src={four8} alt="Bid_credit_protection" />
                </span>
              </div>
              <div>
                <p>
                  Good–Better–Best (GBB) Bid Options
                  <br />
                  <span>
                    Offer tiered estimates for clearer, higher-converting
                    proposals.
                  </span>
                </p>
              </div>
            </div>

            <div className="expand-area">
              <p className="text-center">
                <span>
                  Founding member pricing valid for one year from subscription
                  date. After the initial year, subscription will automatically
                  renew at standard pricing.
                </span>
              </p>
            </div>

            <div className="form-actions-upgrate">
             <button
                  type="button"
                  className="next-btn"
                  onClick={() => {
                    handleViewDetails();
                    handleSubscriptionWhenNoPlan();
                  }}
                >
                  Upgrade to Pro Now - $99/month{" "}
                </button>
              {/* <button type="button" className="back-btn mt-3">
                Pass - Forfeit Founding Offer{" "}
              </button> */}
            </div>
          </div>

          {/* Buttons */}
          <div className="form-actions">
            <button
              type="submit"
              className="next-btn"
              onClick={submitFourthStep}
            >
              Complete Setup (Skip)
            </button>
            <div className="d-flex justify-content-center mt-2">
              <button
                type="button"
                className="back-btn"
                onClick={() => navigate("/professional/signup-three")}
              >
                ← Back
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignUpStepFour;
